export default "__VITE_ASSET__Bp$5HTrx__"